import type {
  ExportData,
  IDataTransferService,
} from '@/domain/precon-supporter/services/IDataTransferService';

/**
 * データエクスポートユースケース
 *
 * 学習履歴データをエクスポート用形式で取得する。
 */
export class ExportDataUseCase {
  constructor(private readonly dataTransferService: IDataTransferService) {}

  /**
   * 全データをエクスポート
   * @returns エクスポートデータ
   */
  async execute(): Promise<ExportData> {
    return this.dataTransferService.exportAllData();
  }
}
